import { industries } from '../../data/industries';
import Button from '../common/Button';

function IndustriesPreview() {
  return (
    <section className="industries-band" aria-labelledby="industries-preview-title">
      <div className="container industries-band__inner">
        <div className="industries-band__intro">
          <h2 id="industries-preview-title">Industries We Serve</h2>
          <p>We support gearbox and hydraulic repair needs for industrial customers across Canada.</p>
          <Button to="/industries" variant="outline-light">
            View All Industries
          </Button>
        </div>
        <div className="industries-band__list">
          {industries.map((industry) => (
            <article key={industry.id} className="industry-tile">
              <span className="industry-tile__icon-wrap" aria-hidden="true">
                <img className="industry-tile__icon" src={`${process.env.PUBLIC_URL}${industry.icon}`} alt="" />
              </span>
              <h3>{industry.title}</h3>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default IndustriesPreview;
